<template>
    <IosUpgradeOverlay v-if="showUpgrade" />
    <div v-else class="main-bg">
        <div class="wrap">
            <div class="main-box flex flex-col justify-center text-center">
                <div class="error-img">
                    <picture v-if="props.status==2">
                      <source :srcset="staticURL('/images/fail-data.webp')" type="image/webp">
                      <img :src="staticURL('/images/fail-data.png')" alt="fail-data">
                    </picture>
                    <picture v-else>
                      <source :srcset="staticURL('/images/no-data.webp')" type="image/webp">
                      <img :src="staticURL('/images/no-data.png')" alt="no-data">
                    </picture>
                </div>
                <h1 class="font16 color-f">{{ props.status==2 ? t('common.loadingfail') : t('common.noData') }}</h1>
                <div
                    class="btn-default auto"
                    :class="{ 'is-hidden': props.status !== 2 }"
                    :aria-hidden="props.status !== 2"
                    @click="props.status === 2 && refresh()"
                >{{ props.status === 2 ? t('common.refresh') : '' }}</div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
    import { computed } from 'vue'
    import { useI18n } from 'vue-i18n'
    import { isIosUpgradeRequired } from '@/utils/iosCompat'

    const { t } = useI18n()
    const props = withDefaults(
    defineProps<{
        /** 状态 */
        status?: number;
    }>(),
    {
        status: () => 1,  
    }
    );

    const showUpgrade = computed(() => isIosUpgradeRequired() && props.status === 2)

    const refresh = () => {
        window.location.reload()
    }
</script>
<style scoped lang="scss">
    .main-bg{
        padding: 150px 0;
        .main-box{
            margin:0 auto;
        
            .error-img{
                img{
                    display: block;
                    width: auto;
                    max-height: 80px;
                    margin: 0 auto;
                }
            }
            h1{
                margin: 11px 0 12px;
                font-weight: normal;
            }
            .btn-default{
                width: 130px;
                &.is-hidden {
                    visibility: hidden;
                    pointer-events: none;
                }
            }
        }
    }
    
    @media only screen and (max-width:991px){
        .main-bg{
            padding: 75px 0 30px;
            .main-box{
                min-height: calc(100vh - 105px);
            }
        }
    }
    @media only screen and (max-width:767px){
        .main-bg{
            padding: 50px 0 30px;
            .main-box{
                min-height: calc(100vh - 85px);
            }
        }

    }
</style>
